export default __webpack_public_path__ + "static/media/copy.d7d94de2.svg";